import React, { useEffect, useState } from "react";
import moment from "moment";

const EmployeeActivityInsightsTable = ({ email }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState("--");
    const [endDate, setEndDate] = useState("--");

    const today = moment();
    const startOfLastWeek = today.clone().startOf('isoWeek').subtract(1, 'weeks'); // Last Monday
    const endOfLastWeek = today.isoWeekday() === 1
        ? startOfLastWeek.clone().add(3, 'days') // Thursday (Mon + 3)
        : startOfLastWeek.clone().add(4, 'days'); // Friday (Mon + 4)

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (email) {
                params.append("email", email);
            }

            params.append("start_date", startOfLastWeek.format("YYYY-MM-DD"));
            params.append("end_date", endOfLastWeek.format("YYYY-MM-DD"));

            const response = await fetch(
                `${process.env.REACT_APP_CRM}/admin/employee/productivity?${params.toString()}`
            );

            const result = await response.json();
            const fetchedData =
                result && result.data && Array.isArray(result.data) ? result.data : [];

            setData(fetchedData);

            setStartDate(startOfLastWeek.format("YYYY-MM-DD"));
            setEndDate(endOfLastWeek.format("YYYY-MM-DD"));


        } catch (error) {
            console.error("Error fetching activity insights:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [email]);

    return (
        <div className="title emps_mob">
            <span className="job_title">
                Weekly Activity Insights{" "}
                <span
                    style={{
                        fontSize: "14px",
                        fontWeight: "normal",
                        marginLeft: "10px",
                        color: "#555",
                    }}
                >
                    ({startDate !== "--" && endDate !== "--"
                        ? `${moment(startDate).format("Do MMMM")} - ${moment(endDate).format("Do MMMM")}`
                        : "--"})
                </span>
            </span>

            {loading ? (
                <p>Loading...</p>
            ) : data.length === 0 ? (
                <p>No Activity Insights Found.</p>
            ) : (
                data.map((emp) => (
                    <div className="row intra_form mt-3" key={emp.id}>
                        <div className="col-md-6 col-xs-12">

                            <div className="form-group row">
                                <label className="col-sm-6 col-xs-5 col-form-label">
                                    Emails Sent
                                </label>
                                <div className="col-sm-6 col-xs-7">
                                    <span className="per_old_fields">
                                        {emp.emails_sent !== undefined && emp.emails_sent !== null ? emp.emails_sent : 0}
                                    </span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-xs-5 col-form-label">
                                    Meetings Attended
                                </label>
                                <div className="col-sm-6 col-xs-7">
                                    <span className="per_old_fields">
                                        {emp.meetings_attended !== undefined && emp.meetings_attended !== null ? emp.meetings_attended : 0}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-xs-12">
                            <div className="form-group row">
                                <label className="col-sm-6 col-xs-5 col-form-label">
                                    Hours in Meeting
                                </label>
                                <div className="col-sm-6 col-xs-7">
                                    <span className="per_old_fields">
                                        {typeof emp.total_hours_spent === "number"
                                            ? emp.total_hours_spent.toFixed(2)
                                            : "0.00"}
                                    </span>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-6 col-xs-5 col-form-label">
                                    Avg. Minutes Late
                                </label>
                                <div className="col-sm-6 col-xs-7">
                                    <span className="per_old_fields">
                                        {emp.average_minutes_late !== undefined && emp.average_minutes_late !== null ? emp.average_minutes_late : 0}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-xs-12">
                            <div className="form-group row">
                                <label className="col-sm-6 col-xs-5 col-form-label">
                                    Number of Chats (28 days)
                                </label>
                                <div className="col-sm-6 col-xs-7">
                                    <span className="per_old_fields">
                                        {typeof emp.chat_messages_sent_last28days === "number"
                                            ? emp.chat_messages_sent_last28days
                                            : "0"}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                ))
            )}
        </div>
    );
};

export default EmployeeActivityInsightsTable;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/EmployeeActivityInsightsTable.js